import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@7f-ui/components/skeleton/skeleton';
import { SkeletonCards } from 'src/shared/composites/skeleton-cards';
export function AppExperienceSuggestionsLoading() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center justify-between gap-4"><Skeleton className="h-10 w-56" /><Skeleton className="hidden h-10 w-28 rounded-full sm:block" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bleed-container py-8" aria-hidden={true}><div className="grid gap-6 px-6 md:px-0">{t0}<div className="flex gap-4 overflow-hidden"><SkeletonCards variant="wide" mobileSize="fixed" count={3} className="min-w-64 flex-1" /></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export function AppWhoWeAreLoading() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex-1"><Skeleton className="aspect-square rounded-xl md:aspect-3/2" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="fluid-container flex flex-col gap-8 sm:flex-row-reverse sm:justify-between sm:gap-16" aria-hidden={true}>{t0}<div className="flex flex-1 flex-col gap-4"><Skeleton className="h-10 w-48" /><Skeleton className="h-5 w-full" /><Skeleton className="h-5 w-11/12" /><Skeleton className="h-5 w-10/12" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}